import { Component, Input } from '@angular/core';
import { SortEvent } from 'primeng/api';
@Component({
  selector: 'bid-tools-table',
  templateUrl: './tools-table.component.html',
  styleUrls: ['./tools-table.component.scss'],
})
export class ToolsTableComponent {
  @Input() headerTable;
  @Input() bodyTable;

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      const value1 = data1[event.field];
      const value2 = data2[event.field];
      let result = null;
      if (event.field === 'date') {
        const x = value1.split('/');
        const y = value2.split('/');
        const dateA = x[2] + x[1] + x[0];
        const dateB = y[2] + y[1] + y[0];

        result = dateA < dateB ? -1 : dateA > dateB ? 1 : 0;
      } else {
        if (value1 == null && value2 != null) {
          result = -1;
        } else if (value1 != null && value2 == null) {
          result = 1;
        } else if (value1 == null && value2 == null) {
          result = 0;
        } else if (typeof value1 === 'string' && typeof value2 === 'string') {
          result = value1.localeCompare(value2);
        } else {
          result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
        }
      }

      return event.order * result;
    });
  }
}
